import React, { useEffect, useRef } from "react";
import { AnimatePresence, motion } from "motion/react";
import { X } from "lucide-react";
import { ImpressumContent } from "./ImpressumContent";

export function ImpressumModal({ open, onClose }) {
    const panelRef = useRef(null);

    useEffect(() => {
        if (!open) return;

        const onKeyDown = (e) => {
            if (e.key === "Escape") onClose();
        };

        document.addEventListener("keydown", onKeyDown);

        const original = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        setTimeout(() => panelRef.current && panelRef.current.focus(), 0);

        return () => {
            document.removeEventListener("keydown", onKeyDown);
            document.body.style.overflow = original;
        };
    }, [open, onClose]);

    return (
        <AnimatePresence>
            {open ? (
                <motion.div
                    className="fixed inset-0 z-[999] flex items-center justify-center p-4"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    {/* overlay */}
                    <button
                        type="button"
                        onClick={onClose}
                        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                        aria-label="Impressum schließen"
                    />

                    {/* panel */}
                    <motion.div
                        ref={panelRef}
                        tabIndex={-1}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="impressum-title"
                        className="relative w-full max-w-3xl max-h-[85vh] overflow-hidden rounded-2xl border border-gray-200/70 bg-white shadow-2xl outline-none"
                        initial={{ y: 18, scale: 0.98, opacity: 0 }}
                        animate={{ y: 0, scale: 1, opacity: 1 }}
                        exit={{ y: 10, scale: 0.99, opacity: 0 }}
                        transition={{ duration: 0.2, ease: "easeOut" }}
                    >
                        <div className="flex items-center justify-between gap-3 border-b border-gray-200/70 px-5 py-4">
                            <div>
                                <div className="text-xs text-gray-500">Rechtliches</div>
                                <h2 id="impressum-title" className="text-lg font-semibold text-gray-900">
                                    Impressum
                                </h2>
                            </div>

                            <button
                                type="button"
                                onClick={onClose}
                                className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white hover:bg-gray-50"
                                aria-label="Schließen"
                            >
                                <X className="h-5 w-5" />
                            </button>
                        </div>

                        <div className="max-h-[calc(85vh-72px)] overflow-y-auto px-5 py-5">
                            <ImpressumContent />
                        </div>

                        <div className="border-t border-gray-200/70 px-5 py-4 flex justify-end">
                            <button
                                type="button"
                                onClick={onClose}
                                className="rounded-xl bg-gradient-to-r from-blue-600 to-purple-600 px-4 py-2 text-sm font-medium text-white hover:from-blue-700 hover:to-purple-700"
                            >
                                Schließen
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            ) : null}
        </AnimatePresence>
    );
}
